import Quill from 'quill';
import { UploadFileInfoModel } from 'shared-components';

const blotPath = 'formats/image';
const BlockEmbed = Quill.import(blotPath);

class ImageBlot extends BlockEmbed {
  public static create(data: UploadFileInfoModel) {
    const src = data.src ?? '';

    const node = super.create(src);
    node.setAttribute('src', data.src);
    node.setAttribute('width', data.width ?? '');
    node.setAttribute('height', data.height ?? '');
    node.setAttribute('alt', data.alt ?? '');

    return node;
  }

  public static value(domNode: any): object {
    return {
      alt: domNode.getAttribute('alt') ?? '',
      height: domNode.getAttribute('height') ?? '',
      src: domNode.getAttribute('src'),
      width: domNode.getAttribute('width') ?? ''
    };
  }
}

ImageBlot.tagName = 'img';
ImageBlot.blotName = 'image';

export default ImageBlot;
